import i18n from "src/i18n/config";
import { z } from "zod";

import { SimplePolicyRule } from "../types";
import { invalidPackage, packageName, requiredMessage, toList } from "../utils";

const kioskAppsPreference = {
    command: "changePreference",
    package: "com.emteria.kiosk",
    category: "com.emteria.kiosk_preferences",
    key: "prefs_allowed_apps",
    type: "set",
};

const kioskAppsSchema = z
    .object({ apps: z.array(z.string()).min(1, { error: requiredMessage }) })
    .superRefine(({ apps }, context) => {
        if (apps.some((name) => !packageName.test(name))) {
            context.addIssue({ code: "custom", path: ["apps"], message: invalidPackage() });
        }
    });

export const kioskApps: SimplePolicyRule<z.infer<typeof kioskAppsSchema>> = {
    id: "kioskApps",
    title: () => i18n.t("modals:addRule.rules.kioskApps.title"),
    description: () => i18n.t("modals:addRule.rules.kioskApps.description"),
    details: () => i18n.t("modals:addRule.rules.kioskApps.details"),
    summary: (_, { apps }) => i18n.t("modals:addRule.rules.kioskApps.summary", { count: apps.length }),
    categories: ["kiosk"],
    fields: [
        {
            type: "list",
            name: "apps",
            label: () => i18n.t("modals:addRule.rules.kioskApps.apps"),
            itemLabel: () => i18n.t("common:label.packageName"),
            itemPattern: packageName,
            itemError: invalidPackage,
            itemSource: "uploadedApps",
        },
    ],
    defaultValues: { apps: [] },
    schema: kioskAppsSchema,
    command: kioskAppsPreference,
    toValues: ({ apps }) => apps.join(","),
    fromValues: (value) => ({ apps: toList(value) }),
    flags: [],
};
